import React from 'react';
import ExperianOutputComponent from './ExperianOutputComponent';

// Safe wrapper to prevent object rendering errors
const SafeValue = ({ value }) => {
    if (value === null || value === undefined) {
        return 'N/A';
    }
    
    if (typeof value === 'object') {
        // If it's an object with title and message, render those
        if (value.title && value.message) {
            return (
                <>
                    <div className="font-semibold mb-2">{String(value.title)}</div>
                    <div className="text-600">{String(value.message)}</div>
                </>
            );
        }
        // Otherwise stringify it
        return JSON.stringify(value);
    }
    
    // For primitives, just convert to string
    return String(value);
};

// Wrapper component that intercepts and fixes data before passing to the real component
const ExperianOutputComponentSafe = ({ hideCredits, ...props }) => {
    // Deep clone and sanitize the reportData to prevent object rendering issues
    const sanitizeData = (data) => {
        if (!data) return data;
        
        if (Array.isArray(data)) {
            return data.map(sanitizeData);
        }
        
        if (typeof data === 'object' && data !== null) {
            const sanitized = {};
            for (const key in data) {
                const value = data[key];
                
                // Special handling for information fields that might cause errors
                if (key === 'information' && typeof value === 'object' && value.title && value.message) {
                    // Convert to a safe string format
                    sanitized[key] = {
                        title: String(value.title || ''),
                        message: String(value.message || '')
                    };
                } else {
                    sanitized[key] = sanitizeData(value);
                }
            }
            return sanitized;
        }
        
        return data;
    };
    
    const safeProps = {
        ...props,
        reportData: sanitizeData(props.reportData),
        hideCredits
    };

    return <ExperianOutputComponent {...safeProps} />;
};

export default ExperianOutputComponentSafe;